import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';

import {App} from './app';
// The html/body reset and fonts, then everything the app draws.
import './styles/document.css';
import './styles/ballot.css';
import './styles/phone.css';
import './styles/presenter.css';

const container = document.getElementById('root');

if (!container) throw new Error('No #root element to mount into');

createRoot(container).render(
    <StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </StrictMode>,
);
